// extracted by mini-css-extract-plugin
export default {"container":"HeaderExtra_container__O9gkK"};